import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '../../../components/special/LanguageProvider';
import { apiPostCall } from '../../../components/special/apiCall';
import  InputDropDownList from 'components/input/InputDropDownList';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const SettingInterest = ({ definition, interestList }) => {   
    const [settingValue, setSettingValue] = useState(JSON.parse(definition.value));    
    const { t } = useLocale();

    const onUpdateValue = (value) => {
        let jsonValue = JSON.stringify(value);
        if (jsonValue != definition.value){
            apiPostCall(BASE_URL + '/admin/setting/save', {...definition, value : jsonValue}).then(res => {      
                setSettingValue(value);
            });        
        }
    }

    return (       

      <div className="table-wrap form">
        <table className="table">
            <colgroup>
                <col/>                
                <col />
            </colgroup>
        <thead>
        </thead>
        <tbody>                  
            <tr>
                <td className="no-border"><div className="form">{t(definition.name)}</div></td>                       
                <td className="no-border"> <InputDropDownList                          
                          list={interestList}
                          keyField="itemID"
                        //   displayField = { (item) => { return item.name + " " + (item.data ? "("+item.data.key+")" : ""); } }
                            displayField = "name"
                          defaultValue = {settingValue}
                          onChange={(value) => onUpdateValue(value)}
                          nullable={true}
                          nullableItem={ {itemID : null, name : ""} }/> </td>
            </tr>
        </tbody>
        </table>
      </div>         
      );
};


export default SettingInterest;
